import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslationService } from '../../../../services/translation.service';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuService } from '../../../../services/menu.service';
import { MenuNode } from '../../../../classes/MenuNode';
@Component({
  selector: 'screen-waterpressure',
  templateUrl: './waterpressure.component.html',
  styleUrls: ['./waterpressure.component.scss']
})
export class WaterpressureComponent implements OnInit {
	@Input('debug') debug:boolean;
  	value:string;
  	unit:string;
  	dashIcon:string;
    node:MenuNode;
    getTitle():string{
      return this.node.getTitle();
    }
    getSubtitle():string{
      return this.node.getSubTitle();
    }
    getText(idx:number):string{
      return this.node.getText(idx);
    }
    getTranslator():TranslationService{
      return this.translator;
    }
    hasParameter(p:string):boolean{
      return this.node.hasParameter(p);
    }

  	constructor(private translator: TranslationService, private ioService: DataIoService, private menuService: MenuService) {
  		this.value="1.5";
  		this.unit="bar";
  		this.dashIcon='';//'iconWarning';
  	}
    program : any;
    subscription:any;
    eventHandler(event){
      if(event == "back"){

                if(this.node.hasBackTarget()){
                  
                  let bt = this.node.getBackTargetNode();
                  console.debug("going back to "+bt.getIdentifier());
                  this.menuService.goto(bt);
                  return;
                }
                if(!this.menuService.historyBack()){
                  console.debug("going back hierarchy up");
                  this.menuService.hierarchyUp();
                  return;
                }  
              }
             if(event == "confirm"){
               let t = this.node.getTargetNode();
               if(t){
                 this.menuService.goto(t);
                 return;
               }
             }
    }
  	ngOnInit() {
      this.node = this.menuService.getCurrentNode();
      if(this.node.hasProgram()){
        this.program = this.node.getProgram();
        this.program(this);
      }
      this.subscription = this.ioService.inputs.events$.subscribe(
          (event) => { 
            this.eventHandler(event);
          }
        );
  	}
    ngOnDestroy(){
      if(this.subscription){
        this.subscription.unsubscribe();
      }
    }

}
